export const filterNullSalesValues = (offer) => {
    const options = offer?.pricings?.[0]?.prices?.options ?? {
        monthly: [],
        oneOff: [],
    };

    const monthly = options?.monthly?.filter(({ sales }) => sales);
    const oneOff = options?.oneOff?.filter(({ sales }) => sales);

    return {
        ...offer,
        pricings: [{ prices: { options: { monthly, oneOff } } }],
    };
};

export const formatProductPricing = (product, offer) => {
    const matchingPricing = offer.pricings.find((pricing) => pricing.product?.id === product.id);

    if (!matchingPricing) {
        return null;
    }

    return {
        ...product,
        type: matchingPricing.type,
        price: matchingPricing.cost,
        options: filterNullSalesValues(matchingPricing)?.prices?.options,
    };
};
